module.exports = __webpack_public_path__ + "img/value-blocks-slider-ford.6ffcf072.png";